/**
 * Time and duration formatting utilities
 * Used across TUC processes for consistent time representation
 */

/**
 * Format duration in minutes to HH:MM:SS format
 *
 * @param minutes - Duration in minutes
 * @returns Time string in HH:MM:SS format (e.g., "01:30:00")
 */
export const formatTimeToHHMMSS = (minutes: number): string => {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:00`
}

/**
 * Format duration in minutes to ISO 8601 duration format
 *
 * @param minutes - Duration in minutes
 * @returns ISO 8601 duration string (e.g., "PT01H30M00S") or null if minutes is null/undefined
 *
 * @example
 * formatDurationISO8601(90) // "PT01H30M00S"
 * formatDurationISO8601(15) // "PT00H15M00S"
 * formatDurationISO8601(null) // null
 */
export const formatDurationISO8601 = (minutes: number | null | undefined): string | null => {
  if (minutes === null || minutes === undefined) {
    return null
  }

  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60

  return `PT${String(hours).padStart(2, '0')}H${String(mins).padStart(2, '0')}M00S`
}
